import pagarme from 'pagarme'

const {
  REACT_APP_PAGARME_KEY,
} = process.env

export const createPagarmeClient = () => pagarme.client.connect({ encryption_key: REACT_APP_PAGARME_KEY })
